import { RotateCw } from "lucide-react";
import { Typography } from "./typography";

function relativeTime(isoDate: string): string {
  const diff = Date.now() - new Date(isoDate).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}

export type RecapData = {
  summary: string | null;
  firstName: string | null;
  lastSaved: string | null;
};

export function RecapCard({ data }: { data: RecapData }) {
  const loading = !data.summary;

  return (
    <div className="mb-6 rounded-2xl bg-white shadow-sm border border-border/30 p-6 space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <RotateCw
            className={`h-4 w-4 text-text-light${loading ? " animate-spin" : ""}`}
            aria-hidden="true"
          />
          <h3 className="text-base font-semibold text-text">What we know so far</h3>
        </div>
        {data.lastSaved && (
          <span className="text-xs text-text-light">Last saved {relativeTime(data.lastSaved)}</span>
        )}
      </div>
      {loading ? (
        <div className="space-y-2">
          <div className="h-3 w-3/4 rounded bg-secondary/60 animate-pulse" />
          <div className="h-3 w-1/2 rounded bg-secondary/60 animate-pulse" />
        </div>
      ) : (
        <Typography.Hint className="leading-relaxed">{data.summary}</Typography.Hint>
      )}
    </div>
  );
}
